import { Alert, List, Text } from '@mantine/core'
import { IconAlertTriangle } from '@tabler/icons-react'
import type { EmergenciaForaDoCodigo } from '@/api/waf'
import { descreverAcao } from './acoesDoModulo'

function quando(iso: string | null): string {
  if (!iso) return '?'
  const d = new Date(iso)
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleString('pt-BR', {
    day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })
}

/**
 * A emergência que o código ainda não tem (spec 2026-10-14 D8, D9). A aberta
 * é aviso, com o pedido que a codifica; a que ficou sem pedido, ou com o pedido
 * recusado, é vermelha — a falha não some da tela.
 */
export function FaixaEmergencias({ emergencias }: { emergencias: EmergenciaForaDoCodigo[] }) {
  if (!emergencias.length) return null
  const falhou = emergencias.some(e => e.estado !== 'aberta')
  return (
    <Alert
      role="status"
      color={falhou ? 'red' : 'yellow'}
      variant="light"
      icon={<IconAlertTriangle size={20} />}
      title="Emergência aplicada na AWS e ainda fora do código"
    >
      <List size="sm" spacing={4}>
        {emergencias.map(e => (
          <List.Item key={e.id}>
            <Text span size="sm" fw={600}>#{e.id}</Text>
            {` (${quando(e.criada_em)}): `}
            {e.acao ? descreverAcao(e.acao) : 'ação'}
            {e.estado === 'aberta' && e.pedido_id != null && (
              <Text span size="sm">{` — pedido de codificação #${e.pedido_id} em andamento`}</Text>
            )}
            {e.estado === 'sem_pedido' && (
              <Text span size="sm" c="red">{' — o pedido de codificação não abriu'}</Text>
            )}
            {e.estado === 'pedido_recusado' && (
              <Text span size="sm" c="red">{` — o pedido de codificação #${e.pedido_id} terminou sem codificar`}</Text>
            )}
          </List.Item>
        ))}
      </List>
      {falhou && (
        <Text size="xs" mt="xs">
          Até o código ter a mudança, o próximo apply do stage a desfaz e os pedidos do stage são
          recusados pela deriva. Peça "Trazer o código para o estado da AWS" abaixo.
        </Text>
      )}
    </Alert>
  )
}
